import type { JobOffer } from '@vv/common';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { JobCard } from '../JobCard';

/** `from` is the stand page's own, passed on so the job's back link keeps it. */
export function JobsTab({ jobs, from }: { jobs: JobOffer[]; from?: string }): ReactElement {
  const { t } = useTranslation();

  if (jobs.length === 0) {
    return <p className="py-6 text-fog-500">{t('stand.noJobs')}</p>;
  }

  return (
    <ul className="space-y-4">
      {jobs.map((job) => (
        <li key={job.id}>
          <JobCard job={job} {...(from !== undefined && { from })} />
        </li>
      ))}
    </ul>
  );
}
